export default __webpack_public_path__ + "static/media/logo_dixa.8be18afc.png";